import config from './config'
import theme from './theme'

export default {
    config,
    theme
}